<template lang="pug">
  .table-responsive
    table#tbCotizaciones.table.is-striped.is-fullwidth
      thead
        tr
          th.is-size-6
            | #
          th.is-size-6
            | Presupuesto
          th.is-size-6
            | IRGE
          th.is-size-6
            | Ducto
          th.is-size-6
            | TPA
          th.is-size-6
            | Partida
          th.is-size-6
            | Observación
          th.is-size-6
            | Descarga
      tbody
        tr(v-for="(pres, index) in presupuestos" :key="pres.id")
          td
            a.button.is-black.is-rounded.is-small
              | {{ index + 1 }}
          td
            span.tag.is-black
              | {{ pres.id_presupuesto }}
          td
            span.tag.is-black
              | {{ pres.id_presupuesto }}
          td
            span.tag.is-black
              | {{ pres.id_presupuesto }}
          td
            span.tag.is-black
              | {{ pres.ubicacion }}
          td
            span.tag.is-black
              | {{ pres.partida }}
          td
            span.tag.is-black
              | {{ pres.observacion }}
          td
            a.button.is-danger.is-small.is-rounded(:href="getRuta(pres.rutaFile)" target='_blank' rel='noreferer noopener')
              i.fas.fa-file-pdf
</template>

<script>
  export default {
    name: 'TbPresupuestos',
    props: {
      presupuestos: {
        type: Array,
        default: []
      },
    },
    methods: {
      convertConceptos(pres) {
        switch (pres.concepto) {
          case 0:
            return 'Gastos Administravos'
          case 1:
            return 'Gastos de Operación'
          case 2:
            return 'Gastos de Seguridad'
          case 3:
            return 'Gastos de Mantto. Preventivo'
          case 4:
            return 'Gastos de Mantto. Correctivo'
          case 5:
            return 'Gastos de Administración (OPS)'
          case 6:
            return 'Gastos de Inst. y Sist.'
          case 7:
            return 'Nuevos Proyectos'
        }
      },
      getRuta(ruta) {
        const currentUrl = window.location.hostname

        return `https://${currentUrl}${ruta}`
      }
    },
  }
</script>

<style lang="css" scoped>
  .control .is-tag-top {
    margin-top: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/presupuestos_Componentes/componentes/TablaPresupuestos.vue